import type { FormField } from "../types";

/**
 * Core fields collected on every use-case form. Their answers map to dedicated
 * columns in the Google Sheet (`first_name`, `last_name`, `work_email`,
 * `audience_size`, `current_yir_program`); the Apps Script bundles everything
 * else into a `vertical_answers` JSON blob.
 *
 * Order is the wizard order. `work_email` comes first so the lead can be saved
 * (as a `partial` row) before the visitor answers anything else. Fields that
 * share a `step` key render together on one page: first + last name, then
 * audience size + current program.
 */
export const CORE_FIELDS: FormField[] = [
  {
    key: "work_email",
    type: "email",
    label: "Work email",
    placeholder: "you@company.com",
    required: true,
    core: true,
  },
  {
    key: "first_name",
    type: "text",
    label: "First name",
    placeholder: "Sam",
    required: true,
    core: true,
    step: "name",
  },
  {
    key: "last_name",
    type: "text",
    label: "Last name",
    placeholder: "Reyes",
    required: true,
    core: true,
    step: "name",
  },
  {
    key: "audience_size",
    type: "select",
    label: "Approximate audience size",
    required: true,
    core: true,
    step: "qualify",
    options: [
      { value: "less-100", label: "Fewer than 100" },
      { value: "100-1000", label: "100 – 1,000" },
      { value: "1000-10000", label: "1,000 – 10,000" },
      { value: "more-10000", label: "More than 10,000" },
    ],
  },
  {
    key: "current_yir_program",
    type: "select",
    label: "Do you run a recurring audience campaign today?",
    required: true,
    core: true,
    step: "qualify",
    options: [
      { value: "yes-every-year", label: "Yes, regularly" },
      { value: "tried-once", label: "Tried once" },
      { value: "planning", label: "In planning" },
      { value: "not-yet", label: "Not yet" },
    ],
  },
];
